import { css } from '@emotion/react'
import { useTheme } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { ReactComponent as UserSearch } from 'images/agenda/user-search.svg'
import Permissions from 'types/Permissions.generated'
import { grupoCboVisualizarProntuario } from 'view/cidadao/authorization/acessos'

import MenuAcoesAgendamentoButton from '../MenuAcoesAgendamentoButton'
import { AcaoAgendamentoButtonProps } from '../model-acoesAgendamento'

export interface VisualizarProntuarioButtonProps extends AcaoAgendamentoButtonProps {
  onClick(): void
}

export function VisualizarProntuarioButton(props: VisualizarProntuarioButtonProps) {
  const { tooltip, disabled, isDropdown, onClick } = props
  const theme = useTheme()
  const { analytics } = useAnalytics()

  const handleClick = () => {
    onClick()
    analytics.logEvent('visualizar_prontuario_AG')
  }

  return (
    <CheckPermission hasAnyCbo={[grupoCboVisualizarProntuario]} hasAnyPermission={[Permissions.visualizarProntuario]}>
      <MenuAcoesAgendamentoButton
        text='Visualizar prontuário'
        tooltip={tooltip}
        disabled={disabled}
        isDropdown={isDropdown}
        onClick={handleClick}
        icon={
          <UserSearch
            css={css`
              fill: ${theme.pallete.text.main};
            `}
          />
        }
      />
    </CheckPermission>
  )
}
